import { BaseModel } from "~/model"
import { usePersonnelStore } from "~/stores"

export class ClientModel extends BaseModel {
    static primaryKey = "IDCLIENT"

    get commercial() {
        const personnelStore = usePersonnelStore()
        return personnelStore.itemById[this.IDPERSONNEL] || null
    }

    get nomComplet() {
        return `${this.PRENOM} ${this.NOM}`
    }
}
